<div class="map-control-container" [class.small-buttons]="showSmallButtons" *ngIf="map">
  <div class="map-control-button-wrapper">
    <button
      type="button"
      (click)="onHomeButtonClicked()"
      class="map-control-button"
      [attr.aria-label]="homeButtonLabel"
    ></button>
  </div>
</div>
